let state = {
  config: null,
  curr_position: null
}

export default {
  state
}
